import axios from '@/utils/api'
import modulo from '@/utils/modulo'
import { SET_COUNT_PROCESSOS, SET_FILTRO_PROCESSOS, SET_PROCESSOS, SET_PROCESSO, SET_STATUS, SET_TIPOS_PROCESSOS, SET_VERSAO_SELECIONADA } from '../../../mutation-types'
import empty from './empty'
import FileSaver from 'file-saver'

const state = {
  tiposProcessos: [],
  status: [],
  processos: [],
  processo: {},
  countProcessos: 0,
  versaoSelecionada: 1.0,
  filtroProcessos: empty.state.emptyFiltroProcessos()
}

const getters = {
  tiposProcessos: state => state.tiposProcessos,
  statusProcessos: state => state.status,
  processos: state => state.processos,
  processo: state => state.processo,
  countProcessos: state => state.countProcessos,
  filtroProcessos: state => state.filtroProcessos,
  versaoSelecionada: state => state.versaoSelecionada
}

const mutations = {
  [SET_FILTRO_PROCESSOS] (state, filtroProcessos) {
    state.filtroProcessos.search = filtroProcessos.search
    state.filtroProcessos.status = filtroProcessos.status
    state.filtroProcessos.tipo = filtroProcessos.tipo
    state.filtroProcessos.municipio = filtroProcessos.municipio
  },

  [SET_TIPOS_PROCESSOS] (state, tiposProcessos) {
    state.tiposProcessos = tiposProcessos
  },

  [SET_STATUS] (state, status) {
    state.status = status
  },

  [SET_PROCESSOS] (state, processos) {
    state.processos = processos
  },

  [SET_PROCESSO] (state, processo) {
    state.processo = processo
  },

  [SET_COUNT_PROCESSOS] (state, count) {
    state.countProcessos = count
  },

  [SET_VERSAO_SELECIONADA] (state, versaoSelecionada) {
    state.versaoSelecionada = versaoSelecionada
  }
}

const actions = {

  async totalProcessos ({ commit }) { // eslint-disable-line
    const response = await axios({
      method: 'GET',
      url: modulo.PUBLICO + '/totalProcessos',
      responseType: 'text'
    })

    return response
  },

  async getProcessoByProtocolo ({ commit }, protocolo) { // eslint-disable-line
    if (protocolo) {
      const processo = await axios(
        {
          method: 'GET',
          url: 'processo/withCadastro/' + protocolo
        })
      processo.dadosCadastro = JSON.parse(processo.dadosCadastro)
      commit('SET_PROCESSO', processo)
      return processo
    }
  },

  async getDocumentosConferirTitulo ({ commit }, processoId) {
    const data = await axios({
      method: 'GET',
      url: `processo/documentosConferirTitulo/${processoId}`
    })
    return data
  },

  async getDadosProcessoByProtocolo ({ commit }, protocolo) { // eslint-disable-line
    if (protocolo) {
      const processo = await axios(
        {
          method: 'GET',
          url: 'processo/getDadosProcesso/' + protocolo
        })
      return processo
    }
  },

  async getTiposProcessosPromise ({ commit }) {
    return axios({
      url: modulo.PUBLICO + '/tiposProcessos',
      method: 'GET'
    })
  },

  async getTiposProcessos ({ commit }) {
    const result = await axios({
      url: modulo.PUBLICO + '/tiposProcessos',
      method: 'GET'
    })

    commit(SET_TIPOS_PROCESSOS, result)
  },

  async getStatusPromise ({ commit }) {
    return axios({
      url: modulo.PUBLICO + '/statusProcessos',
      method: 'GET'
    })
  },

  async getStatus ({ commit }) {
    const result = await axios({
      url: modulo.PUBLICO + '/statusProcessos',
      method: 'GET'
    })

    commit(SET_STATUS, result)
  },

  async getProcessosByFilterConsulta ({ commit }, parametros) { // eslint-disable-line
    const processos = await axios({
      method: 'POST',
      url: 'publico/consulta/findByFilterCentral',
      data: parametros

    })
    commit('SET_PROCESSOS', processos.content)
    commit('SET_COUNT_PROCESSOS', processos.totalElements)

    return processos
  },

  // Exporta csv com o filtro escolhido
  async getCsvProcessosPublico({ commit }, filtro) { // eslint-disable-line
    const file = await axios({
      method: 'POST',
      url: 'publico/consulta/exportarCsvProcessos',
      responseType: 'blob',
      data: {
        ...filtro
      }
    })

    const dataRelatorio = new Date()
    FileSaver.saveAs(file, 'Consulta_Processos_' + dataRelatorio.toLocaleDateString() + '_' + dataRelatorio.toLocaleTimeString() + '.csv')
  },

  async csvProcessosBloqueio({ commit }) { // eslint-disable-line
    axios({
      method: 'GET',
      url: 'publico/csv/processosBloqueio',
      responseType: 'blob'
    })
  },

  async shapeProcessosBloqueio({ commit }) { // eslint-disable-line
    axios({
      method: 'GET',
      url: 'publico/shape/processosBloqueio',
      responseType: 'blob'
    })
  },

  async getProcessosByFilter ({ commit }, parametros) { // eslint-disable-line
    const processos = await axios({
      method: 'POST',
      url: 'processo/findByFilterCentral',
      data: parametros

    })
    commit('SET_PROCESSOS', processos.content)
    commit('SET_COUNT_PROCESSOS', processos.totalElements)

    return processos
  },
  async getByFilterReceptor ({ commit }, parametros) { // eslint-disable-line
    const params = { ...parametros, pagina: parametros.pagina > 0 ? parametros.pagina - 1 : 0 }
    const processos = await axios({
      method: 'POST',
      url: 'processo/findByFilterReceptor',
      data: params
    })
    return processos
  },

  async getProcessoByProtocoloAndVersao ({ commit }, data) { // eslint-disable-line
    const url = `processo/withCadastro/${data.protocolo}/${data.versao}`
    const processo = await axios(
      {
        method: 'GET',
        url: url.replaceAll('//', '/')
      })
    processo.dadosCadastro = JSON.parse(processo.dadosCadastro)

    commit('SET_PROCESSO', processo)
    return processo
  },

  async getVersoesByProtocolo ({ commit }, protocolo) { // eslint-disable-line
    const versoes = await axios(
      {
        method: 'GET',
        url: 'processo/versoesCadastro/' + protocolo
      })
    return versoes
  },

  async clearProcesso ({ commit }) {
    commit('SET_PROCESSO', empty.state.emptyProcessos().processo)
  },

  async maisSolicitado ({ commit }) { // eslint-disable-line
    const response = await axios({
      method: 'GET',
      url: modulo.PUBLICO + '/tipoProcessoMaisSolicitacoes',
      responseType: 'text'
    })

    return response
  },

  async municipioMaisSolicitacoes ({ commit }) { // eslint-disable-line
    const response = await axios({
      method: 'GET',
      url: modulo.PUBLICO + '/municipiosMaisSolicitacoes ',
      responseType: 'text'
    })

    return response
  },

  async getHistorico ({ commit }, idProcesso) { // eslint-disable-line
    const response = await axios({
      method: 'GET',
      url: 'processo/historico/' + idProcesso
    })

    return response
  },

  async baixarPdfHistorico ({ commit }, idProcesso) {
    await axios({
      method: 'GET',
      url: 'processo/historico/download/' + idProcesso,
      responseType: 'blob'
    })
  },

  async baixarPdfProcesso ({ commit }, idProcesso) {
    await axios({
      method: 'GET',
      url: 'processo/pdfDownload/' + idProcesso,
      responseType: 'blob'
    })
  },

  async baixarPdfProcessoComAnexos ({ commit }, idProcesso) {
    const token = localStorage.getItem('@jwt')
    await axios({
      method: 'GET',
      url: 'processo/pdfDownload/' + idProcesso + '/comAnexos' + `?token=${token}`,
      responseType: 'blob'
    })
  },

  async baixarPdfProcessoViewProcess ({ commit }, idProcesso) {
    await axios({
      method: 'GET',
      url: 'processo/pdfDownload/' + idProcesso + '/' + state.versaoSelecionada,
      responseType: 'blob'
    })
  },

  async baixarHistoricoConversa ({ commit }, idConversa) {
    await axios({
      method: 'GET',
      url: 'processo/conversa/download/' + idConversa,
      responseType: 'blob'
    })
  },

  async getFilterInfo (context) {
    const data = await axios({
      method: 'GET',
      url: `publico/consulta/processos/filterInfo`
    })
    return data
  },

  async findProcessosByFilter (context, filter) {
    const data = await axios({
      method: 'POST',
      url: `publico/consulta/processos/findByFilter`,
      data: filter,
      loader: false
    })
    return data
  },
  async getProcessosCadastrados (context) {
    const data = await axios({
      method: 'GET',
      url: modulo.PUBLICO + '/consulta/processos/count'
    })

    return data
  },

  async getProcessosByMunicipio ({ context }) {
    const data = await axios({
      method: 'GET',
      url: modulo.PUBLICO + '/consulta/processos/processosByMunicipio'
    })

    return data
  },

  async getProcessosByMes ({ context }) {
    const data = await axios({
      method: 'GET',
      url: modulo.PUBLICO + '/consulta/processos/processosByMes'
    })

    return data
  },

  async getListaProcessosCadastrados (context, status) {
    const data = await axios({
      method: 'GET',
      url: modulo.PUBLICO + `/consulta/processos/lista/${status}`
    })

    return data
  },

  async getListaProcessosSetor (context) {
    const data = await axios({
      method: 'GET',
      url: modulo.PUBLICO + `/consulta/processos/setor`
    })

    return data
  },

  async getCsvProcessoPortalTransparencia ({commit}, filtro) {
    axios({
      method: 'POST',
      url: modulo.PUBLICO + '/consulta/processos/exportarCsvPesquisaPortalTransparencia',
      responseType: 'blob',
      data: {
        ...filtro
      }
    })
  },

  async getHistoricoProcessoPublico ({ commit }, idProcesso) { // eslint-disable-line
    const response = await axios({
      method: 'GET',
      url: modulo.PUBLICO + '/consulta/processos/historico/' + idProcesso
    })

    return response
  },

  async getDadosAnaliseAutomatizada ({ commit }, protocolo) { // eslint-disable-line
    const response = await axios({
      method: 'GET',
      url: 'processo/getDadosAnaliseAutomatizada',
      params: {
        protocolo
      }
    })

    return response
  },

  async gerarEspelhoProcesso ({ commit }, idProcesso) {
    await axios({
      method: 'GET',
      url: modulo.PUBLICO + '/consulta/historico/download/' + idProcesso,
      responseType: 'blob'
    })
  },

  async ativarDesativarNotificaWhatsApp ({ commit }, { id, notificarWhatsApp }) {
    return axios({
      method: 'GET',
      url: `processo/ativarDesativarNotificaWhatsApp/${id}/${notificarWhatsApp}`
    })
  },

  async baixarZipProcesso ({ commit }, idProcesso) {
    await axios({
      method: 'GET',
      url: 'processo/zipDownload/' + idProcesso,
      responseType: 'blob'
    })
  },
  async setProcesso ({ commit }, processo) {
    commit(SET_PROCESSO, processo)
  },
  async baixarZipProcessoViewProcess ({ commit }, idProcesso) {
    await axios({
      method: 'GET',
      url: 'processo/zipDownload/' + idProcesso + '/' + state.versaoSelecionada,
      responseType: 'blob'
    })
  },
  async getProcessosParaRetificacao ({ commit }, parametros) { // eslint-disable-line
    const processos = await axios({
      method: 'POST',
      url: 'processo/findByProcessosParaRetificacao',
      data: parametros

    })

    return processos
  },
  async getAnexos ({ commit }, idProcesso) { // eslint-disable-line
    const response = await axios({
      method: 'GET',
      url: `processo/${idProcesso}/anexos/`
    })

    return response
  },
  async cancelarSuspensao ({ commit }, dados) { // eslint-disable-line
    const response = await axios({
      method: 'POST',
      url: `processo/cancelarSuspensao`,
      data: dados
    })

    return response
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/portal/publico/processos.js